{
    "actions": {
        "row": {
            "send_by_mail": "Envoyer par mail",
            "refresh_transaction": "Rafraîchir"
        }
    },
    "count": {
        "transaction": "{{transactionsCount}} transaction",
        "transactions": "{{transactionsCount}} transactions"
    },
    "keys": {
        "reconciliation_number": "N° de remise",
        "remittance_number": "N° de fichier",
        "transaction_date": "Date",
        "reconciliation_code": "Statut",
        "total_amount": "Montant",
        "legal_name": "Nom commercial",
        "transaction_count": "Transactions",
        "total_revenue": "Montant total : {{amount}}"
    },
    "filter": {
        "placeholder": {
            "reconciliation_number": "Filtrer par n° de remise",
            "remittance_number": "Filtrer par n° de fichier",
            "total_amount": "Filtrer par montant",
            "legal_name": "Filtrer par nom commercial",
            "transaction_count": "Filtrer par transactions"
        }
    },
    "modal": {
        "send_by_mail": {
            "success": "Votre demande a bien été prise en compte, l’envoi des mails sera fait d’ici quelques minutes",
            "UNKNOWN_ERROR": "Une erreur est survenue lors de l’envoi des mails",
            "title": {
                "remote_collection": "Ticket de télécollecte par mail",
                "transaction": "Ticket porteur par mail"
            },
            "message": {
                "remote_collection": "Contrat $t(contract:application.{{application}}) n°{{contract}} du {{localTransactionDate}} à {{localTransactionTime}}",
                "transaction": "Contrat $t(contract:application.{{application}}) n°{{contract}}, remise n°{{reconciliationNumber}} du {{localTransactionDate}} à {{localTransactionTime}}"
            },
            "confirm": {
                "single": "Le mail va être envoyé au destinataire suivant :",
                "multiple": "Le mail va être envoyé aux destinataires suivants :"
            }
        }
    },
    "status": {
        "RECONCILED_TOTALS_CORRECT": "Totaux corrects",
        "RECONCILED_TOTALS_INCORRECT": "Totaux incorrects",
        "EMPTY": "Vide",
        "NOT_COMPLETED": "Non aboutie",
        "NOT_EMPTY": "Non vide",
        "TOTALS_INVALID": "Totaux invalides",
        "INTERRUPTED": "Interrompue"
    },
    "toast": {
        "refresh": {
            "loading": "Rafraîchissement en cours...",
            "success": "Rafraîchissement terminé avec succès",
            "error": "Erreur lors du rafraîchissement de la remise"
        }
    }
}